export default __webpack_public_path__ + "static/media/profilePageBgImage.d9a356eb.png";